import React from "react";

export default function MiniFooter() {
  return (
    <footer
      className="border-t border-zinc-200 bg-white py-4 px-6 text-center text-xs text-slate-500"
      data-testid="mini-footer"
    >
      © {new Date().getFullYear()} — DerechoLlave
    </footer>
  );
}
